import { Set } from "./other";
import { isEmpty } from "./validation";

export function selectOrNull<T>(items: T[], filter: (item: T) => boolean): T | null {
  if (isEmpty(items)) {
    return null;
  } else {
    return items.find((i) => filter(i)) || items[0];
  }
}

export function collectUnique<T>(arr: T[], prop: keyof T) {
  const cc = new Set();
  for (const item of arr) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = item[prop] as any;
    if (data) {
      cc.add(data.toString());
    }
  }
  return cc.toArray();
}

interface TextValue {
  value: string;
  text: string;
}
export function collectTextValue(keys: string[], labels: { [k: string]: string }, emptyLabel?: string): TextValue[] {
  if (!keys || keys.length === 0) return [];
  const result: TextValue[] = keys.map((k) => ({
    value: k,
    text: labels[k] || k
  }));
  if (emptyLabel) {
    result.unshift({ value: "", text: emptyLabel });
  }
  return result;
}
